import api from '../axios/axiosConfig';

export const createUser = async (name: string, email: string, password: string, app_id: number = 1) => {
    try {
        const response = await api.post(`/userregister?app_id=${app_id}`, {
            name,
            email,
            password,
        });
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const updatePushNotification = async (payload: any) => {
    try {
        console.log("updatePushNotification: ", payload, ', X-Brand-ID: ', api.defaults.headers.common['X-Brand-ID']);

        const response = await api.post("/UserNotificationTokens", payload);
        //alert('SendExpoTokenToApi: ' + response.status);
        console.log("SendExpoTokenToApi: " + response.status);
    } catch (error: unknown) {
        console.log(error);
    }
}

export const unRegisterPushNotification = async (expoPushToken: string | null, platform: string | null, appVersion: string | null, notificationProvider: string = 'expo', appId?: string) => {
    const payload = {
        PushToken: expoPushToken,
        Platform: platform,
        IsLoggedIn: false,
        AppVersion: appVersion,
        NotificationProvider: notificationProvider,
        ...(appId && { AppId: appId }),
    };

    console.log("unRegisterPushNotification: " + JSON.stringify(payload));

    if (!expoPushToken || !platform || !appVersion) return;

    await updatePushNotification(payload);
}

export const registerPushNotification = async (pushToken: string | null, platform: string | null, appVersion: string | null, notificationProvider: string = 'expo', appId?: string) =>  {
    //console.log("RegisterForPushNotification");

    const payload = {
        PushToken: pushToken,
        Platform: platform,
        IsLoggedIn: true,
        AppVersion: appVersion,
        NotificationProvider: notificationProvider,
        ...(appId && { AppId: appId }),
    };

    console.log("RegisterForPushNotification: " + JSON.stringify(payload));

    if (!pushToken || !platform || !appVersion) return;

    await updatePushNotification(payload);
}

export const getUser = async () => {
    try {
        const response = await api.get(`/userprofile`);
        return response.data;
    } catch (error: any) {
        throw error;
    } 
}

export const updateUser = async (user: any) => {
    try {
        const response = await api.put(`/userprofile`, user);
        return response;
    } catch (error: any) {
        throw error;
    } 
}

export const changePassword = async (payload: any) => {
    try {
        const response = await api.post(`/ChangePassword`, payload);
        return response;
    } catch (error: any) {
        throw error;
    } 
}

export const resetPassword = async (payload: any) => {
    try {
        const response = await api.post(`/ResetPassword`, payload);
        return response;
    } catch (error: any) {
        throw error;
    } 
}

export const getUserVehicles = async () => {
    try {
        const response = await api.get(`/UserVehicles`);
        return response.data;
    } catch (error: any) {
        console.error('Error fetching user vehicles:', error);
        return [];
    } 
}